// Feature: M004-F0718. Tests: T-M004-0219.
//
// Which tab of the booking drawer a viewer last used, remembered per viewer in localStorage (design 16.4).
// EVERY read and write is inside try/catch: a private window, blocked site data or a throwing accessor means "no
// memory" (Booking is the default each time), never an error and never a broken drawer.
export const BOOKING_DRAWER_TAB_STORAGE_KEY = 'studioaeye.bookingDrawerTab';
export const TAB_BOOKING = 'booking';
export const TAB_HISTORY = 'history';
export const TAB_BILLING = 'billing';
export const BOOKING_DRAWER_TABS = Object.freeze([
  { key: TAB_BOOKING, label: 'Booking' },
  { key: TAB_HISTORY, label: 'History' },
  { key: TAB_BILLING, label: 'Billing' },
]);

export const readRememberedTab = () => {
  try {
    const value = globalThis.localStorage.getItem(BOOKING_DRAWER_TAB_STORAGE_KEY);
    return BOOKING_DRAWER_TABS.some((tab) => tab.key === value) ? value : null;
  } catch {
    return null;
  }
};

export const rememberTab = (key) => {
  try {
    globalThis.localStorage.setItem(BOOKING_DRAWER_TAB_STORAGE_KEY, key);
  } catch { /* storage unavailable: the choice just is not remembered */ }
};

// The tab a drawer opens on: an explicit request (a chip click asks for History) wins, then the remembered one,
// else Booking. Only a tab that exists for this drawer can be chosen.
export const initialDrawerTab = (requested) => {
  if (BOOKING_DRAWER_TABS.some((tab) => tab.key === requested)) return requested;
  return readRememberedTab() || TAB_BOOKING;
};
